import React from "react";
import PropTypes from "prop-types";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Box from "@material-ui/core/Box";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import AvatarImageCropper from "react-avatar-image-cropper";

import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    height: 200,
    width: 200,
    fontSize: "3rem",
    marginBottom: "42px",
  },
  imageCrop: {
    height: 200,
    width: 200,
    marginBottom: "42px",
  },
}));

const Profile = ({ user, profileSubmitHandler }) => {
  const classes = useStyles();

  const [editing, setEditing] = React.useState(false);

  return (
    <>
      <Card>
        <CardContent>
          <Box alignItems="center" display="flex" flexDirection="column">
            {editing ? (
              <div className={classes.imageCrop}>
                <AvatarImageCropper
                  maxsize={1024 * 1024 * 20}
                  apply={(picture) => {
                    const data = new FormData();
                    data.append("image", picture);
                    profileSubmitHandler(data);
                  }}
                />
              </div>
            ) : user.image ? (
              <Avatar className={classes.avatar} src={user.image} />
            ) : (
              <Avatar className={classes.avatar}>{`${user.firstName.charAt(
                0
              )}${user.lastName.charAt(0)}`}</Avatar>
            )}
            <Typography color="textPrimary" gutterBottom variant="h3">
              {`${user.firstName} ${user.lastName}`}
            </Typography>
            <Typography color="textSecondary" variant="body1">
              {`${user.company.name}`}
            </Typography>
          </Box>
        </CardContent>
        <Divider />
        <CardActions>
          <Button
            color="primary"
            fullWidth
            variant="text"
            component="label"
            onClick={(e) => {
              setEditing(!editing);
            }}
          >
            {editing ? "Cancel" : "Update image"}
          </Button>
        </CardActions>
      </Card>
    </>
  );
};

Profile.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    image: PropTypes.string,
    role: PropTypes.string,
    created: PropTypes.string,
    updated: PropTypes.string,
    company: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      image: PropTypes.string,
      created: PropTypes.string,
      updated: PropTypes.string,
      OwnerId: PropTypes.number,
    }),
  }),
};

export default Profile;
